import { FC } from 'react';
import cx from 'classnames/bind';

import Packs from '@/assets/packs.png';
import { Modal } from '@/components/Modal';
import { getWordWithEnding } from '@/utils/getWordWithEnding';

import styles from './ModalCollectOrder.module.scss';

interface ModalCollectOrderProps {
  modal: string;
  setModal: (value: string) => void;
  totalPoints: number;
  timer: number;
  setStep: (value: number) => void;
}

const cn = cx.bind(styles);

const ModalCollectOrder: FC<ModalCollectOrderProps> = ({
  modal,
  setModal,
  totalPoints,
  timer,
  setStep,
}) => {
  const time = `${timer} ${getWordWithEnding(timer, [
    'секунду',
    'секунды',
    'секунд',
  ])}`;

  const numberGames = 10; // Количество игр за баллы
  const numberPointsPerGame = totalPoints / numberGames;
  const points = `${numberPointsPerGame} ${getWordWithEnding(
    numberPointsPerGame,
    ['эксперт-балл', 'эксперт-балла', 'эксперт-баллов'],
  )}`;

  const handleClick = () => {
    setStep(3);
    setModal('');
  };

  return modal === 'collectOrder' ? (
    <Modal
      src={Packs}
      title="Как собрать заказ?"
      textButton="Выбрать новый заказ"
      handleClick={handleClick}
    >
      <ul className={cn('modal-list')}>
        <li className={cn('modal-item')}>
          Верно выберите характеристики продукта за {time}
        </li>
        <li className={cn('modal-item')}>
          За правильный сбор заказа вы получите {points}
        </li>
        <li className={cn('modal-item')}>
          Эксперт-баллы приносят только первые 10 заказов
        </li>
      </ul>
    </Modal>
  ) : null;
};

export default ModalCollectOrder;
